import { transitioningDetailsResource } from './services/index.tsx';

export const resources = () => [transitioningDetailsResource];
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { transitioningDetailsResource } from './services';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { TransitioningDetailsResponse } from './services/types';
